import endpoints from '../../config/endpoints';
import http from '../shared/http';
import intl from '../shared/intl';
import { handleActions } from 'redux-actions';
import { create as paginationCreate } from '../shared/pagination';
import createCalendar from '../shared/calendar';
import { formatEnumFormOptions } from '../shared/format';
import { SubmissionError, getFormValues, reset, change } from 'redux-form';
import { actions as rootActions, REFETCH_ALL_DATA } from '../root';
import { LOCATION_CHANGE, replace } from 'react-router-redux';
import moment from 'moment';

import values from 'lodash/values';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import find from 'lodash/find';
import _reduce from 'lodash/reduce';
import uniqBy from 'lodash/uniqBy';

import { formatMoney } from '../shared/format';

import formatPayouts from './components/payout-table/format-payouts';
import formatCurrencyConversions from './components/currency-conversion-table/format-list';

const isRocket = process.env.CPA_ENV === 'rocket';

const calendar = createCalendar({
	namespace: 'finances',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(6, 'days').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const pagination = paginationCreate('finances', {
	FinancesTable: {
		currentPage: 1,
		perPage: 10
	}
});

// actions
const FINANCES_FETCH_DATA_SUCCESS = 'finances/fetch-data-success';
const FINANCES_FETCH_DATA_ERROR = 'finances/fetch-data-error';

const SORT_BY_COLUMN = 'finances/sort-by-column';
const SHOW_MORE_ROWS = 'finances/show-more-rows';
const TOGGLE_PROGRESS_BAR = 'finances/toggle-progress-bar';

const ORDER_PAYOUT_SUCCESS = 'finances/order-payout-success';
const ORDER_PAYOUT_ERROR = 'finances/order-payout-error';

const CHANGE_CURRENCY = 'finances/change-currency';
const TOGGLE_EXCHANGE_CURRENCY = 'finances/toggle-exchange-currency-switch';

const tableTypeEnum = {
	history: 'history',
	conversions: 'conversions',
	payouts: 'payouts',
	points: 'points'
};

// initial state
const initialState = {
	data: null,
	historyTable: {
		getColumns: state => ({
			'date': {
				id: 'date',
				direction: 'desc',
				position: 'date',
				title: 'Дата',
				className: 'date'
			},
			'hold_amount': {
				id: 'hold_amount',
				direction: 'desc',
				position: 'hold_amount',
				title: 'Холд',
				className: 'hold'
			},
			'amount': {
				id: 'amount',
				direction: 'desc',
				position: 'amount',
				title: 'Баланс',
				className: 'amount'
			},
			'comment': {
				id: 'comment',
				direction: 'desc',
				position: 'comment',
				title: 'Категория',
				className: 'comment'
			}
		}),
		columnSorting: {
			key: 'date',
			direction: 'desc',
			position: 'date',
			title: 'Дата'
		}
	},
	conversionsTable: {
		getColumns: state => ({
			'created_at': {
				id: 'created_at',
				direction: 'desc',
				position: 'date',
				title: 'Дата создания'
			},
			..._reduce(
				state.app.lists['available-currencies'],
				(acc, val) => {
					acc[`balance_${val.id}`] = {
						id: `balance_${val.id}`, title: `Баланс`, className: `balance-${val.id}`
					};
					return acc;
				},
				{}
			),
			'comment': {
				id: 'date',
				title: 'Комментарий'
			}
		}),
		columnSorting: {
			key: 'date',
			direction: 'desc',
			position: 'date',
			title: 'Дата'
		}
	},
	payoutsTable: {
		getColumns: state => ({
			'created_at': {
				id: 'created_at',
				direction: 'desc',
				position: 'payout.created_at',
				title: 'Дата создания',
				className: 'date'
			},
			'id': {
				id: 'id',
				direction: 'desc',
				position: 'payout.id',
				title: 'ID',
				className: 'id'
			},
			'amount': {
				id: 'amount',
				direction: 'desc',
				position: 'payout.amount',
				title: 'Сумма',
				className: 'amount'
			},
			'system': {
				id: 'system',
				direction: 'desc',
				position: 'payout.system',
				title: 'Способ вывода',
				className: 'system'
			},
			'closed_at': {
				id: 'closed_at',
				direction: 'desc',
				position: 'payout.paid_at||payout.rejected_at',
				title: 'Дата закрытия',
				className: 'date'
			},
			'status': {
				id: 'status',
				direction: 'desc',
				position: 'payout.status',
				title: 'Статус платежа',
				className: 'status'
			}
		}),
		columnSorting: {
			key: 'created_at',
			direction: 'desc',
			position: 'created_at',
			title: 'Дата'
		}
	},
	pointsTable: {
		getColumns: state => ({
			'date': {
				id: 'date',
				direction: 'desc',
				position: 'date',
				title: 'Дата',
				className: 'date'
			},
			'conversion_id': {
				id: 'conversion_id',
				direction: 'desc',
				position: 'conversion_id',
				title: 'Конверсия',
				className: 'conversion'
			},
			'amount': {
				id: 'amount',
				direction: 'desc',
				position: 'amount',
				title: 'Поинты',
				className: 'points-amount'
			},
			'comment': {
				id: 'comment',
				direction: 'desc',
				position: 'comment',
				title: 'Категория',
				className: 'comment',
				disabled: true
			}
		}),
		columnSorting: {
			key: 'date',
			direction: 'desc',
			position: 'date',
			title: 'Дата'
		}
	},
	showProgressBar: false,
	pagination: pagination.initState,
	calendar: calendar.initialState,
	selectedCurrency: null,
	error: false
};

// actions
export const actions = Object.assign({
	fetchData: () => (dispatch, getState) => {
		const state = getState().finances;
		const dateRange = state.calendar && state.calendar.value || state.calendar.defaultValue;
		const activeCurrency = currentCurrency(getState());

		let date_start = moment(dateRange.start)
			.set({ 'hours': 0, 'minutes': 0, 'seconds': 0 })
			.format('YYYY-MM-DD HH:mm:ss');
		let date_end = moment(dateRange.end)
			.set({ 'hours': 23, 'minutes': 59, 'seconds': 59 })
			.format('YYYY-MM-DD HH:mm:ss') || moment().format('YYYY-MM-DD HH:mm:ss');

		const nonUsdExchangeCurrency = selectors.getListOfExchangeCurrencies(getState())
			.find(c => c.id !== 'usd');

		const request = http({
			url: [
				`${endpoints.FINANCES.HISTORY}?currency=${activeCurrency}
				&date_range[start]=${date_start}&date_range[end]=${date_end}&simple_list=true`,
				endpoints.FINANCES.AFFILIATE_PAYOUTS,
				endpoints.PROFILE.PAYOUT_SYSTEMS,
				`${endpoints.FINANCES.POINTS}?date_range[start]=${date_start}&date_range[end]=${date_end}`,
				`${endpoints.FINANCES.RATES}?currency=${nonUsdExchangeCurrency ? nonUsdExchangeCurrency.id : ''}`,
				endpoints.FINANCES.CURRENCY_CONVERSIONS,
				`${endpoints.FINANCES.HISTORY}/rub?limit=1`
			],
			method:'get',
			actions: [
				FINANCES_FETCH_DATA_SUCCESS,
				FINANCES_FETCH_DATA_ERROR
			],
			addToResponse: {
				currency: selectors.getHeaderCurrency(getState()),
				payoutStatuses: selectors.getStatuses(getState())
			}
		});

		request(dispatch);
	},

	toggleExchangeCurrencySwitch: value => (dispatch, getState) => {
		dispatch({type: TOGGLE_EXCHANGE_CURRENCY, payload: value});
		const state = getState();
		const activeCurrency = selectors.getHeaderCurrency(state);

		// get activePayoutMethodData
		const isExchangeMode = (state.finances.data &&
			state.finances.data.exchange_currency) !== activeCurrency;
		const payoutMethods = state.finances.data[
			isExchangeMode ? 'payoutMethodsExchange' : 'payoutMethods'
		];
		const initialPaymentMethod = payoutMethods[0] || {};

		dispatch(change('paymentsForm', 'payment', initialPaymentMethod.payout_setting_id));
	},

	pagination: () => dispatch => pagination.actions(dispatch),

	sortByColumn: columnKey => (dispatch, getState) => {
		const tableType = getState().routing.locationBeforeTransitions.pathname.split('/')[2];
		dispatch({
			type: SORT_BY_COLUMN,
			payload: {columnKey, tableType}
		});
	},

	showMoreRows: tableType => ({
		type: SHOW_MORE_ROWS,
		payload: tableType
	}),

	orderPayout: (data, exchangeMoney) => (dispatch, getState) => {
		const state = getState();
		const activeCurrency = selectors.getHeaderCurrency(state);
		const isExchangeMode = (state.finances.data &&
			state.finances.data.exchange_currency) !== activeCurrency;
		const { payment } = getFormValues('paymentsForm')(getState());
		const payoutMethods = state.finances.data[
			isExchangeMode ? 'payoutMethodsExchange' : 'payoutMethods'
		];
		const payoutMethod = find(payoutMethods, { payout_setting_id: getSelectValue(payment) });
		const amount = data.amount && data.amount.replace(/ /g, '');

		const exchange_currency = state.finances.data && state.finances.data.exchange_currency;
		const exchangeRates = state.finances.data && state.finances.data.exchangeRates;
		const {selling_rate, buying_rate } = exchangeRates;

		const exchange_rate = exchange_currency === 'usd' ? selling_rate: buying_rate;
		const exchange_coefficient = exchange_currency === 'usd' ?
			1/(exchange_rate || 0): (exchange_rate || 0);
		const exchangeMoney = (amount || '0').split(' ').join('') * exchange_coefficient;
		const transferAmount = exchangeMoney && isExchangeMode ? exchangeMoney : amount;
		const translator = intl(getState());
		const confirmText = translator(
			`Вы точно хотите заказать сумму %s %s на %s?`,
			(Math.round(transferAmount * 100)/100).toString(),
			payoutMethod.currency,
			payoutMethod.title
		);

		if (!confirm(confirmText)) {
			return dispatch(reset('paymentsForm'));
		}

		dispatch(actions.toggleProgressBar());

		const request = http({
			url: endpoints.FINANCES.PAYOUTS,
			method: 'post',
			actions: [
				ORDER_PAYOUT_SUCCESS,
				ORDER_PAYOUT_ERROR
			],
			data: {
				amount: payoutMethod.allow_floats ? parseFloat(amount) : Math.floor(amount),
				currency: isExchangeMode ? activeCurrency : undefined,
				payout_setting_id: payoutMethod.payout_setting_id
			}
		});

		return request(dispatch).then(action => {
			dispatch(actions.toggleProgressBar());

			if (action.type === ORDER_PAYOUT_SUCCESS) {
				dispatch(actions.toggleProgressBar());
				dispatch(replace('/finances/payouts/'));

				if (isRocket) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ event: 'withdraw' });
				}
			}

			if (action.type === ORDER_PAYOUT_ERROR && action.payload.response.status === 400) {
				const validationsErrors = {};
				const responseErrors = action.payload.response.data;

				forEach(responseErrors, value => {
					const key = value.dataPath.slice(1);
					validationsErrors[key] = value.message;
					if (!validationsErrors.amount) {
						validationsErrors.amount = value.message;
					}
				});

				throw new SubmissionError(validationsErrors);
			}
		})
			.then(() => dispatch(rootActions.refetchAll()));
	},

	toggleProgressBar: () => ({
		type: TOGGLE_PROGRESS_BAR
	}),

	changeCurrency: currencyId => dispatch => {
		dispatch(actions.toggleProgressBar());
		dispatch({ type: CHANGE_CURRENCY, payload: currencyId});
		dispatch(actions.fetchData());
	}
}, calendar.actions);

// reducers
const reducers = Object.assign({
	[LOCATION_CHANGE]: (state, action) => {
		if (action.payload.pathname.indexOf('finances') == -1) {
			return initialState;
		} else {
			return { ...state };
		}
	},
	[FINANCES_FETCH_DATA_SUCCESS]: (state, action) => {
		const [
			history, payouts, payoutMethods, pointsTransactions, currentRates, conversions,
			rubHistory
		] = action.payload;
		const activeCurrency = action.meta.currency;

		const filteredPayoutMethods = filter(payoutMethods.data, sys => {
			return sys.currency == activeCurrency && sys.credentials && !isEmpty(sys.credentials);
		});
		const filteredPayoutMethodsExchange = filter(payoutMethods.data, sys => {
			return sys.currency !== activeCurrency && sys.credentials && !isEmpty(sys.credentials);
		});
		const zaleyCash = filteredPayoutMethods.find(p => p.module === 'zaleycash');
		if (zaleyCash) {
			for (let submodule in zaleyCash.credentials) {
				const subCredentials = zaleyCash.credentials[submodule];
				if (submodule !== 'email' && !isEmpty(subCredentials)) {
					filteredPayoutMethods.push({
						...zaleyCash,
						title: `${submodule} - ${zaleyCash.title}`,
						id: `${zaleyCash.id}.${submodule}`
					});
				}
			}
		}

		return {
			...state,
			showProgressBar: false,
			data: {
				history: history.data,
				conversions: conversions && formatCurrencyConversions(conversions.data),
				payouts: formatPayouts(payouts.data, action.meta.payoutStatuses),
				points: pointsTransactions.data,
				payoutSystems: payoutMethods.data,
				payoutMethods: filteredPayoutMethods,
				payoutMethodsExchange: filteredPayoutMethodsExchange,
				exchange_currency: activeCurrency,
				hasRubHistory: !!rubHistory.data && rubHistory.data.length,
				exchangeRates: currentRates.data
			}
		};
	},
	[FINANCES_FETCH_DATA_ERROR]: (state, action) => {
		return { ...state, error: true, showProgressBar: false };
	},
	[TOGGLE_EXCHANGE_CURRENCY]: (state, action) => {
		return {
			...state,
			data: {
				...state.data,
				exchange_currency: action.payload
			}
		};
	},
	[SORT_BY_COLUMN]: (state, action) => {
		const { tableType, columnKey }  = action.payload;
		const table = state[[`${tableType}Table`]];
		const { columnSorting, columns } = table;

		const columnDirection = columnSorting && columnSorting['key'] === columnKey
			? columnSorting.direction === 'desc' ? 'asc' : 'desc'
			: columns[columnKey].direction;
		return {
			...state,
			[`${tableType}Table`]: {
				...table,
				columnSorting: {
					...columns[columnKey],
					key: columnKey,
					// duck tape for disabling order on points category
					direction: tableType === 'points' && columnKey === 'comment'
						? [`${tableType}Table`].columnSorting.direction
						: columnDirection
				}
			}
		};
	},
	[SHOW_MORE_ROWS]: (state, action) => {
		const tableName = `${action.payload}Table`;
		return {
			...state,
			[tableName]: {
				...state[tableName],
				rowsNumber: state[tableName].rowsNumber + initialState[tableName].rowsNumber
			}
		};
	},
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
	[ORDER_PAYOUT_SUCCESS]: (state, action) => {
		return { ...state, progressBar: false };
	},
	[REFETCH_ALL_DATA]: () => initialState,
	[CHANGE_CURRENCY]: (state, action) => ({
		...state,
		selectedCurrency: action.payload
	})
}, pagination.reducers, calendar.reducers);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.finances.data,
	currencyBalances: state => {
		const {balances} = state.app.userData;
		return Object.assign({}, ...balances.map(i => ({[i.currency]: i.amount})));
	},
	getUserId: state => get(state, 'app.userData.general.id'),
	getTableTypeEnum: tableTypeEnum,
	getFormInitialValues: state => {
		if (!state.finances.data) return null;

		const activeCurrency = selectors.getHeaderCurrency(state);
		const foundBalance = find(state.app.userData.balances, it => it.currency === activeCurrency);
		const exchange_currency = state.finances.data && state.finances.data.exchange_currency;
		// get activePayoutMethodData
		const isExchangeMode = exchange_currency !== activeCurrency;
		const payoutMethods = state.finances.data[isExchangeMode ? 'payoutMethodsExchange' : 'payoutMethods']
			.filter(paymentMethod => !exchange_currency || exchange_currency === paymentMethod.currency);

		const initialPaymentMethod = payoutMethods[0] || {};
		const paymentsFormData = getFormValues('paymentsForm')(state);
		const paymentMethod = paymentsFormData
			&& paymentsFormData.payment
			&& find(payoutMethods, { payout_setting_id: getSelectValue(paymentsFormData.payment) })
			|| initialPaymentMethod;

		return {
			payment: paymentMethod.payout_setting_id,
			paymentMethodOptions: payoutMethods.map(entity => ({
				credentials: entity.credentials,
				label: entity.title,
				value: entity.payout_setting_id,
				image: entity.image,
				purse: ['wmz', 'wmr'].indexOf(entity.title.toLowerCase()) > -1 ? entity.credentials.purse : ''
			})),
			minAmount: paymentMethod.min_amount,
			allowFloats: paymentMethod.allow_floats,
			amount: foundBalance && foundBalance.amount && formatMoney(
				foundBalance.amount, paymentMethod.allow_floats
			) || 0,
			currency: activeCurrency || 'usd',
			exchange_currency: activeCurrency || 'usd',
			payout_percent: paymentMethod.payout_percent || 0,
			payout_fee: paymentMethod.payout_fee || 0
		};
	},
	getTableHeaders: state => tableType => {
		const table = state.finances[[`${tableType}Table`]];

		return values(table.getColumns(state));
	},
	getExchangeForm: state =>  {
		return {
			...getFormValues('paymentsForm')(state)
		};
	},
	getColumnSorting: state => tableType => {
		const table = state.finances[[`${tableType}Table`]];
		return table.columnSorting;
	},
	getTableData: state => tableType => {
		const table = state.finances[[`${tableType}Table`]];
		const statuses = formatEnumFormOptions(state.app.lists['payout-statuses']);
		let data = state.finances.data && state.finances.data[tableType] || [];

		if (tableType === tableTypeEnum.history) {
			const categoriesFilter = getFormValues('categoriesFilter')(state);
			const filterCategoryValue = categoriesFilter && categoriesFilter.category.value;
			data = data.filter(entity => {
				const category = commentToCategoryMapper(entity.comment, Number(entity.amount) < 0);

				return (filterCategoryValue === 'all' || category === filterCategoryValue);
			});
		}

		if (tableType === tableTypeEnum.payouts) {
			const payoutSystemsFilter = getFormValues('payoutSystemsFilter')(state);
			const payoutSystemValue = payoutSystemsFilter && payoutSystemsFilter.system.value;
			data = data.filter(entity => {
				return payoutSystemValue === 'all' || entity.payout.system.id === payoutSystemValue;
			});
		}

		if (tableType === tableTypeEnum.points) {
			const pointCategoriesFilter = getFormValues('pointCategoriesFilter')(state);
			const filterCategoryValue = pointCategoriesFilter && pointCategoriesFilter.category.value;
			data = data.filter(entity => {
				if (filterCategoryValue === 'all') {
					return true;
				}
				if (filterCategoryValue === 'auto') {
					return ['auto', 'auto-write-off'].includes(entity.status);
				}

				return entity.status === filterCategoryValue;
			});
		}

		return pagination.selectors.getPageData(
			state => data && sortTable(table.columnSorting, data, statuses),
			state => state.finances.pagination.FinancesTable.perPage,
			state => state.finances.pagination.FinancesTable.currentPage
		)(state);
	},
	getStatuses: state => formatEnumFormOptions(state.app.lists['payout-statuses']),
	getProgressBar: state => state.finances.showProgressBar,
	getUserLang: state => (
		state.app.userData &&
		state.app.userData.general &&
		state.app.userData.general.language
	),
	getExchangeData: state => {
		return {
			exchange_currency: state.finances.data && state.finances.data.exchange_currency,
			exchangeRates: state.finances.data && state.finances.data.exchangeRates
		};
	},
	getIntl: intl,
	getCalendar: state => calendar.selectors.getCalendar(
		state => state.finances.calendar,
		state => state
	)(state),
	getListOfCurrencies: state => state.app.userData.balances.map(item => ({
		id: item.currency,
		text: item.currency
	})),
	getListOfExchangeCurrencies: state => {
		const payoutCurrencies = state.app.lists['exchange-currencies'];

		return selectors.getListOfCurrencies(state)
			.filter(c => payoutCurrencies.some(pc => pc.id === c.id));
	},
	getListOfAvailableCurrencies: state => {
		const availableCurrencies = state.app.lists['available-currencies'];

		return availableCurrencies.map(ac => ac.id);
	},
	getActiveCurrency: state => currentCurrency(state),
	getHeaderCurrency: state => state.app.userData && state.app.userData.activeBalance,
	getTotalData: state => {
		if (!state.finances.data) return null;

		const { balances } = state.app.userData;
		const currentBalance = find(balances, {currency:currentCurrency(state)});
		const { history, points } = state.finances.data;

		const initial = {
			'approve': 0,
			'creation': 0,
			'paid': 0,
			'income': 0,
			'hold': currentBalance['hold_amount'],
			'points': points.reduce((acc, item) => acc + parseFloat(item.amount), 0)
		};

		return history.reduce((acc, entity) => {
			const category = commentToCategoryMapper(entity.comment);
			const amountKey = category === 'paid' ? 'hold_amount' : 'amount';
			const currentEntityAmount = Number(
				amountKey === 'hold_amount' ? Math.abs(entity[amountKey]) : entity[amountKey]
			);

			acc[category] = acc[category] ? (acc[category] + currentEntityAmount) : currentEntityAmount;

			return acc;
		}, initial);
	},
	getPayoutSystemsFilterData: state => {
		const translator = intl(state);

		const data = state.finances.data;
		const payoutSystems = data && data.payoutSystems;

		const options = [{
			value: 'all',
			label: translator('Все системы')
		}];

		if (payoutSystems) {
			options.push(...uniqBy(payoutSystems, 'id').map((system) => ({
				value: system.id,
				label: system.title
			})));
		}

		return {
			options,
			initialValue: { system: options[0] }
		};
	},
	getCategoriesFilterData: state => {
		const translator = intl(state);

		const options = [{
			label: translator('Все категории'),
			value: 'all'
		}, {
			label: translator(categoryToNameMapper.approve),
			value: 'approve'
		}, {
			label: translator(categoryToNameMapper.paid),
			value: 'paid'
		}, {
			label: translator(categoryToNameMapper.income),
			value: 'income'
		}, {
			label: translator(categoryToNameMapper.canceled),
			value: 'canceled'
		}, {
			label: translator(categoryToNameMapper.withdrawal),
			value: 'withdrawal'
		}];

		const initialValue = {
			category: options[0]
		};

		return {
			options,
			initialValue
		};

	},
	getPointCategoriesFilterData: state => {
		const translator = intl(state);

		const options = [{
			label: translator('Все категории'),
			value: 'all'
		}, {
			label: translator(categoryToNameMapper.auto),
			value: 'auto'
		}, {
			label: translator(categoryToNameMapper.manual),
			value: 'manual'
		}];
		isRocket && (
			options.push({
				label: translator(categoryToNameMapper.order),
				value: 'order'
			})
		);

		const initialValue = { category: options[0] };

		return { options, initialValue };
	},
	getError : state => state.finances.error
};

function getValueByPositions(row, positions) {
	for (const position of positions) {
		const value = get(row, position, null);

		if (value !== null) {
			return value;
		}
	}
}

const sortTable = (sortedColumn, rows, statuses) => {
	if (!rows || !sortedColumn.position) return [];

	const positions = sortedColumn.position.split('||');

	return orderBy(rows, row => {
		const value = getValueByPositions(row, positions);

		switch (sortedColumn.position) {
			case 'status':
				return statuses.find(s => s.value == row.status).label;
			case 'payout.system':
				return value.name;
			case 'payout.status':
				return value.label;
			default:
				return value;
		}
	}, sortedColumn.direction);
};

const currentCurrency = state => {
	if (state.finances.selectedCurrency) {
		return state.finances.selectedCurrency;
	}
	if (isRocket) {
		return 'usd';
	}
	return state.app.userData && state.app.userData.activeBalance;
};

export const commentToCategoryMapper = (comment, isNegative = false) => {
	switch (comment) {
		case 'conversion approve':
		case 'bonus':
		case 'geo amount correction':
		case 'geo bonus correction':
			return 'approve';
		case 'CPL conversion payment':
			return 'cplConversionPayment';
		case 'CPL conversion bonus withdrawal':
			return 'CplBonusWithdrawal';
		case 'CPL conversion bonus':
			return 'CplBonus';
		case 'approved conversion rejection':
		case 'approved conversion bonus rejection':
			return 'canceled';
		case 'CPL conversion withdrawal':
			return 'cplConversionWithdrawal';
		case 'payout creation':
			return 'creation';
		case 'payout paid':
			return 'paid';
		case 'moved hold to balance':
			return 'holdToBalance';
		case 'moved balance to hold':
			return 'balanceToHold';
		case 'payout rejection':
			return 'rejection';
		case 'money from novostnik':
			return 'extraMonetization';
		case 'order bm account':
			return 'orderBmAccount';
		case 'Guaranteed approve payment':
			return 'guaranteedApprovePayment';
		default:
			return isNegative ? 'withdrawal': 'income';
	}
};

export const pointCommentToCategoryMapper = {
	'auto': 'Автоначисление',
	'auto-write-off': 'Автосписание',
	'manual': 'Ручная корректировка',
	'order': 'Заказ товара'
};

export const categoryToNameMapper = {
	approve: 'Заработано',
	cplConversionPayment: 'Заработано за CPL лид',
	canceled: 'Отменено',
	cplConversionWithdrawal: 'Отклонено за CPL лид',
	CplBonusWithdrawal: 'Отклонен бонус за CPL лид',
	CplBonus: 'Начислен бонус за CPL лид',
	creation: 'Создание выплаты',
	paid: 'Выплачено',
	income: 'Начислено',
	withdrawal: 'Списано',
	holdToBalance: 'Перевод с холда на баланс',
	balanceToHold: 'Перевод с баланса на холд',
	rejection: 'Отмена выплаты',
	auto: 'Авто',
	manual: 'Корректировка',
	order: 'Заказ',
	orderBmAccount: 'Покупка аккаунта',
	guaranteedApprovePayment: 'Гарант аппрува конверсий',
	extraMonetization: 'Доп. монетизация'
};

/**
 *  @todo Think about how to fix the problem
 *  If react-select control has initialize value "option id" and work with redux-form
 *  we have two behavior when using getFormData selector.
 *  1) When not fire redux-form onChange method  result is plain value
 *  2) When fire onChange result is object
 */
const getSelectValue = selectValue => isObject(selectValue) ? selectValue.value : selectValue;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/index.js